<template>
  <div>
    <div class="coming-soon">
      <Banner @applied="newApplication" />
      <SuccessModal :id="id" :position="position" />
      <event-details />
      <memories-row v-if="false"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
import Banner from "@/components/home/Banner";
import EventDetails from "@/components/home/EventDetails";
import MemoriesRow from "@/components/home/MemoriesRow";
import SuccessModal from "@/components/home/SuccessModal";
import RecordViews from "@/mixins/RecordViews";
import sendNotification from "@/services/sendNotification";
import axios from "axios";

const betaTemplate = "d-b846a6e727d1438c8728b7fedc5a532c";

export default {
  name: "Home_Site",
  components: {
    Banner,
    EventDetails,
    MemoriesRow,
    SuccessModal
  },
  mixins: [RecordViews],
  computed: {
    ...mapGetters({
      position: "user/userCount"
    })
  },
  methods: {
    newApplication(form) {
      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store.dispatch("user/submitRSVP", { form, ip }).then(res => {
          this.$bvModal.show(this.id);
         // logEvent(this.analytics, 'signup_beta');
        });
        this.notify([form]);
      });
    },
    notify([form]) {
      sendNotification(
        "Invitation List", //subject
        [form], //user_ids,emails
        ["email"], //comm_types
        `Your Position in the List is ${this.position}`, //msg
        "hi@cornerqr.com", //from
        betaTemplate //tplId
      )
        .then(res => {
          console.log("sent", res);
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    getPublishings() {
      this.$store.dispatch("listings/getListPublishings").then(publishings => {
        this.publishings = publishings;
        this.loading = false;
      });
    }
  },
  mounted() {
    this.getPublishings();
  },
  data() {
    return {
      id: "success-modal",
      config,
      loading: false,
      publishings: [
        {
          cornerURL: "/corner/the-little-ant-that-did",
          isNew: true,
          rating: 5,
          bio: "info about the book",
          imgURL:
              "https://firebasestorage.googleapis.com/v0/b/cornerqr.appspot.com/o/publishing_cover_img%2FAxXOetC3aD2DgMa?alt=media&token=02c2e90f-85db-4df1-b549-b2ec5b2171eb"
        },
        {
          cornerURL: "/corner/the-little-ant-that-did",
          isNew: true,
          rating: 5,
          bio: "info about the book",
          imgURL:
              "https://firebasestorage.googleapis.com/v0/b/cornerqr.appspot.com/o/publishing_cover_img%2FAxXOetC3aD2DgMa?alt=media&token=02c2e90f-85db-4df1-b549-b2ec5b2171eb"
        },
        {
          cornerURL: "/corner/the-little-ant-that-did",
          isNew: true,
          rating: 5,
          bio: "info about the book",
          imgURL:
              "https://firebasestorage.googleapis.com/v0/b/cornerqr.appspot.com/o/publishing_cover_img%2FAxXOetC3aD2DgMa?alt=media&token=02c2e90f-85db-4df1-b549-b2ec5b2171eb"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.coming-soon {
  padding-top: 100px;
  background: #FE828C;
}
</style>
